import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "m10.59 15.303-1.18 1.179a4.167 4.167 0 1 1-5.892-5.893l1.178-1.178m10.607 1.178 1.178-1.178a4.167 4.167 0 0 0-5.892-5.893L9.41 4.697m-2.327 8.22 5.833-5.834"
    }, null, -1)
  ])))
}
export default { render: render }